import { render } from "./Booking_Hotel.vue?vue&type=template&id=ace25354&scoped=true"
import script from "./Booking_Hotel.vue?vue&type=script&lang=js"
export * from "./Booking_Hotel.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-ace25354"

export default script